import { Form, Formik } from "formik";
import { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { AppContext } from "../../../appContext/AppContext";
// import GenerateFormComponent from "../../../component/generate-form/GenerateFormHTMLNoValid";
import { generateForm } from "../../../utils/AppFunction";
// import "./index.scss";
import { formatDateDTO } from "../../../utils/FormatUtils";
import ModelHeader from "../../../component/ModelHeader";
import BackButton from "../../BackButton";
import { OctGenerateForm } from "@oceantech/oceantech-ui";
import { ids } from "webpack";
import { updateVatTu } from "../QuanLyKhoServices";
import { CODE } from "../../../utils/Constant";


interface Props {
  show: boolean;
  onHide: () => void;
  initialValues?: any;
  modelId: any;
  warehouseId?: number;
}

const DialogThongTinVatTu = (props: Props) => {
  const { show, onHide, initialValues, modelId, warehouseId } = props;
  const { setIsLoading } = useContext(AppContext);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [lstItem, setLstItem] = useState<any>([])


  useEffect(() => {
    if (initialValues[modelId]?.id) {

    }
  }, [initialValues[modelId]?.id]);

  useEffect(() => {
    updateForm();
  }, [modelId]);

  const validationSchema = Yup.object({
    [modelId]: Yup.object({
    })
  })

  const updateForm = async () => {
    const data = await generateForm(modelId);
    setListJsonGenerate(data || []);
  };

  const handleSubmit = async (values: any) => {
    const newValues = values[modelId];
    let inventoryItemId = values[modelId]?.inventoryItemId;

    try {
      setIsLoading(true)
      const data = {
        ...newValues,
        id: null
      }
      const res = await updateVatTu(data, inventoryItemId);
      if (res?.data?.code === CODE.SUCCESS) {
        onHide();
      }
    } catch (error) {
      console.error("ERR", error)
    } finally {
      setIsLoading(false)
    }
  };



  const updateData = async () => {
    // try {
    //   setIsLoading(true);
    //   const lstId = lstChecked.map(item => item.id);
    //   const { data } = await getLstItemTongHop(lstId);
    //   if (CODE.SUCCESS === data.code) {   
    //     setLstItem(data.data);
    //   }
    // } catch (error) {
    //   console.error(error);
    // } finally {
    //   setIsLoading(false);
    // }
  };
  useEffect(() => {
    updateData();
  }, []);
  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50"
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, touched, errors, handleChange, setFieldValue }) => {
          return <Form >
            <Modal.Header className="header-modal spaces h-40px">
              <div className="d-flex align-items-center">
                <div
                  onClick={() => {
                    onHide();
                  }}
                >
                  <BackButton />
                </div>
                <div className="title spaces ml-20">
                  {`Cập nhật vật tư`}
                </div>
              </div>
            </Modal.Header>
            <Modal.Body className="spaces p-0 bg-white">
              <div className="spaces px-10 mb-5">
                <div>
                  <OctGenerateForm
                    warehouseId={initialValues[modelId]?.whReceive?.id || initialValues[modelId]?.whReceiveId}
                    listFieldAuto={listJsonGenerate}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    values={values}
                    touched={touched}
                    errors={errors}
                    modelID={modelId}
                    // customComponent={DynamicComponent}
                    isView={false}
                  />
                </div>
              </div>
            </Modal.Body>
            <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6">
              <Button type="submit" className="btn btn-fill min-w-90px spaces ml-8 mr-4">
                Lưu
              </Button>
              {/* {!isChangeData &&
                <WfButton
                  tracker={WF_TRACKER.TONG_HOP_BO_SUNG}
                  objectId={values[modelId]?.id}
                  additionalFunc={(data?: any) => {
                    setStatusPhieu({
                      status: data?.currCode
                    })
                    data?.currCode && setFieldValue(`${modelId}.statusCode`, data?.currCode)
                  }}
                />
              } */}
            </div>
          </Form>
        }}
      </Formik>
    </Modal>
  );
};

export default DialogThongTinVatTu;
